export { default } from "./InterlinkingBlock";
export type { InterlinkingBlockProps, LinkData, SectionData } from "./type";
